export const formatCurrentBrake = (data) => {
  const [minValue, maxValue] = data.split("-").map(Number);

  return `min${minValue}, max${maxValue}`;
};
